/**
 * 状态管理器 - 购物车
 *
 * @ version 1.0.0
 **/
import {setStore,getStore,removeStore} from '../../utils/storage.js'
export default {
	namespaced: true,
  state: {
    cartList: [],   // 加入购物车列表
    showMoveImg: false, // 显示飞入图片
    elLeft: 0,
    elTop: 0,
    moveImgUrl: null,
    cartPositionT: 0, // 购物车位置
    cartPositionL: 0,
    receiveInCart: false, // 是否进入购物车
    showCart: false // 是否显示购物车
  },
  mutations: {
    // 网页初始化时从本地缓存获取购物车数据
    initcart(state) {
      let initCart = getStore('buyCart')
      if (initCart) {
        state.cartList = JSON.parse(initCart)
      }
    },
    // 加入购物车
    addcart(state, {productId, salePrice, productName, productImg, productNum = 1}) {
      let cart = state.cartList // 购物车
      let falg = true
      let goods = {
        productId,
        salePrice,
        productName,
        productImg
      }
      if (cart.length) {        // 有内容
        cart.forEach(item => {
          if (item.productId === productId) {
            if (item.productNum >= 0) {
              falg = false
              item.productNum += productNum
            }
          }
        })
      }
      if (!cart.length || falg) {
        goods.productNum = productNum
        goods.checked = '1'
        cart.push(goods)
      }
      state.cartList = cart
      // 存入localStorage
      setStore('buyCart', cart)
    },
    // 加入购物车动画
    addanimation(state, {moveShow, elLeft, elTop, img, cartPositionT, cartPositionL, receiveInCart}) {
      state.showMoveImg = moveShow
      if (elLeft) {
        state.elLeft = elLeft
        state.elTop = elTop
      }
      state.moveImgUrl = img
      state.receiveInCart = receiveInCart
      if (cartPositionT) {
        state.cartPositionT = cartPositionT
        state.cartPositionL = cartPositionL
      }
    },
    // 是否显示购物车
    showcart(state, {showCart}) {
      // let timer = null
      state.showCart = showCart
      // clearTimeout(timer)
      // if (showCart) {
      //   timer = setTimeout(() => {
      //     state.showCart = false
      //   }, 5000)
      // }
    },
    // 移除商品
    removecart(state, {productId}) {
      let cart = state.cartList
      cart.forEach((item, i) => {
        if (item.productId === productId) {
          if (item.productNum > 1) {
            item.productNum--
          } else {
            cart.splice(i, 1)
          }
        }
      })
      state.cartList = cart
      // 存入localStorage
      setStore('buyCart', state.cartList)
    },
    // 修改购物车
    editcart(state, {productId, productNum, checked}) {
      let cart = state.cartList
      if (productNum) {
        cart.forEach((item, i) => {
          if (item.productId === productId) {
            item.productNum = productNum
            item.checked = checked
          }
        })
      } else if (productId) {
        cart.forEach((item, i) => {
          if (item.productId === productId) {
            cart.splice(i, 1)
          }
        })
      } else {
        cart.forEach((item) => {
          item.checked = checked ? '1' : '0'
        })
      }
      state.cartList = cart
      // 存入localStorage
      setStore('buyCart', state.cartList)
    }
  },
  actions: {

  }
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js